import React from "react";
import { useParams } from "react-router-dom";
import RepTerritoryPage from "@/pages/RepTerritoryPage";

/** Kept so existing /manager/rep-territory links still work — same unified page. */
const ManagerRepTerritoryPage = ({ user }) => {
  const { repName } = useParams();
  return <RepTerritoryPage user={user} initialRep={repName ? decodeURIComponent(repName) : null} />;
};

export default ManagerRepTerritoryPage;
